import { memo, ReactNode } from 'react';

import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog as MUIDialog,
  DialogProps as MUIDialogProps,
} from '@mui/material';
import { Typography } from '../Typography/Typography';

interface DialogProps extends MUIDialogProps {
  target?: string;
  header?: ReactNode | string;
  main?: ReactNode | string;
  footer?: ReactNode | (() => void);
  submitText?: string;
  hideFooter?: boolean;
  width?: `${number}px` | `${number}%`;
  height?: `${number}px` | `${number}%`;
  open: boolean;
  onClose: () => void;
}

const Dialog = ({
  target,
  header,
  main,
  footer,
  submitText,
  hideFooter = false,
  width,
  height,
  open,
  onClose,
  ...props
}: DialogProps) => (
  <MUIDialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    sx={{ '& .MuiDialog-paper': { width, height } }}
    {...props}
  >
    {header && (
      <DialogTitle>
        {typeof header === 'string' ? (
          <>
            <Typography fontSize="1.25rem" fontWeight="500" lineHeight="32px">
              {header}
            </Typography>
            {target && (
              <Typography fontSize="0.75rem" lineHeight="20px" color="#00000099">
                {target}
              </Typography>
            )}
          </>
        ) : (
          header
        )}
      </DialogTitle>
    )}
    {main && (
      <DialogContent>
        {typeof main === 'string' ? (
          <Typography fontSize="0.875rem" lineHeight="20px">
            {main}
          </Typography>
        ) : (
          main
        )}
      </DialogContent>
    )}
    {!hideFooter && (
      <DialogActions>
        <Button variant="text" color="info" onClick={onClose} sx={{ textTransform: 'none' }}>
          Отменить
        </Button>
        {typeof footer === 'function' ? (
          <Button variant="contained" onClick={footer} color="info" sx={{ textTransform: 'none' }}>
            {submitText ? submitText : 'Подтвердить'}
          </Button>
        ) : (
          footer
        )}
      </DialogActions>
    )}
  </MUIDialog>
);

export const DialogMemo = memo(Dialog);
